import React, { useState } from "react";
import {
  Button,
  Typography,
  Paper,
  Box,
  makeStyles,
  Slide
} from "@material-ui/core";
import { ArrowBackIos } from "@material-ui/icons";
import { Alert } from "@material-ui/lab";
import theme from "../../theme";

import CommonInput from "../input";

const useStyles = makeStyles(() => ({
  container: {
    maxWidth: 500,
    padding: "2rem",
    borderRadius: 12,
    "&.after": {
      transform: "translateX(100px)",
    },
    "&.up": {
      transform: "translateY(100px)"
    },
    "&.before": {
      transform: "translateX(-100px)"
    },
    transition: ".1s ease-in"
  },
  field: {
    marginBottom: "1.5rem",
  },
  button: {
    marginTop: "1rem",
  },
  backArrow: {
    cursor: "pointer",
    color: theme.colors.DodgerBlue
  }
}));

export default function ContactSupportForm({
  backAction = () => { },
  submitted,
  setSubmitted,
  form,
  setForm,
  handleSubmit,

}) {
  const classes = useStyles();

  const [animation, setAnimation] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!form.subject.trim()) newErrors.subject = "Subject is required.";
    if (!form.description.trim()) newErrors.description = "Description is required.";
    return newErrors;
  };

  React.useEffect(() => {
    validate()
  }, [form])

  React.useEffect(() => {
    if (submitted) {
      setForm(s => ({ ...s, subject: '', description: '' }))
    }
  }, [submitted])
  React.useEffect(() => {
    setAnimation(true)
  }, [])
  return (
    <Slide direction="left" in={animation}>
      <Paper elevation={0} className={`${classes.container} ${animation ? "" : "before"}`}>
        <Typography variant="h6" gutterBottom>
          <ArrowBackIos
            className={classes.backArrow}
            onClick={backAction}
          />
          Contact Support
        </Typography>

        {submitted && (
          <Alert severity="success" sx={{ mb: 2 }}>
            Your message has been sent!
          </Alert>
        )}

        <form onSubmit={handleSubmit} noValidate>
          <CommonInput
            fullWidth
            label="Subject"
            name="subject"
            value={form.subject}
            onChange={handleChange}
            // error={!!errors.subject}
            // helperText={errors.subject}
            className={classes.field}
          />

          <CommonInput
            fullWidth
            label="Description"
            name="description"
            value={form.description}
            onChange={handleChange}
            // error={!!errors.description}
            // helperText={errors.description}
            multiline
            rows={4}
            className={classes.field}
          />

          <Box textAlign="right">
            <Button
              variant="contained"
              color="primary"
              type="submit"
              className={classes.button}
              disabled={form?.description?.length <= 5 || form?.subject?.length <=5}
            >
              Send Message
            </Button>
          </Box>
        </form>
      </Paper>
    </Slide>

  );
}
